export interface IWPLinkRequest {
  identifier: string;
  username: string;
  app_password: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}
export interface IMentorkitLMSLinkRequest {
  identifier: string;
  accessToken: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}

export interface ISynthesiaLinkRequest {
  identifier: string;
  accessToken: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}

export enum ELMSType {
  WordPress = 1,
  Mentorkit_LMS = 2,
  Synthesia = 3,
}

export interface IWordpressCourseListItem {
  id: number;
  name: string;
  identifierLMSCourse: string;
  lmsCourseName: string;
  publishURL: string | null;
}

export interface IWordpressCourseListResponse {
  lmsCustomerId: number;
  page: number;
  perPage: number;
  total: number | null;
  totalPages: number | null;
  items: IWordpressCourseListItem[];
}

export interface ILMSIntegrationResponse {
  id?: string;
  success?: boolean;
  message?: string;
  lmsType: ELMSType;
}

export interface IIntegrationItem {
  customerId: number;
  url: string;
  lmsTypeId: ELMSType;
  targetCourse?: { name: string; id: number };
  ownerId?: number;
}

export interface IAddLMSLinkRequest {
  lmsCustomerId: number;
  creatorCourseId: number;
  lmsTypeId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface IAddLMSLinkResponse {
  message: string;
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  creatorCourseId: number;
  lmsTypeId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface ICourseLMSLinkItem {
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  creatorCourseId: number;
  lmsTypeId: ELMSType;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface ILMSUpdateLinkItem {
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
}

export interface IGetLinksByCourseResponse {
  creatorCourseId: number;
  count: number;
  items: ICourseLMSLinkItem[];
}

export interface IExportToPublishRequest {
  courseId: number;
  version: string;
  language: string;
  collectAllFiles: boolean;
  customerLmsLinkId: number | null;
  coverImageUrl: string | null;
}

// Persisted API values: keep these in sync with CreatorUser.Data.EPublishStatus.
// Never renumber or reuse a value.
export enum EPublishStatus {
  Unknown = 0,
  Pending = 1,
  Success = 2,
  SuccessWithWarning = 3,
  SuccessWithCoverImageWarning = 4,
  Failed = 10,
  AuthRequired = 11,
  InvalidCredentials = 12,
  Forbidden = 13,
  MissingTitle = 14,
  InvalidCourse = 15,
  DownloadFailed = 16,
  PackageFailed = 17,
  SaveFailed = 18,
  WorkerFailed = 19,
  InvalidDownloadUrl = 20,
  InvalidCallbackUrl = 21,
  MissingCreatorContext = 22,
  InvalidCoverImageUrl = 23,
  SiteNotReady = 24,
  NotConfigured = 25,
  Timeout = 26,
  SiteUnreachable = 27,
  ExportFailed = 28,
  UnsupportedLmsType = 29,
  InvalidCallback = 30,
  PublishTimeout = 31,
  InternalError = 32,
}

export interface IPublishResultLog {
  creatorCourseId: number;
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  publishDate: string;
  ownerId: number;
  status: EPublishStatus;
  lmsCustomerUrl: string | null;
}

export interface IPublishResult {
  lmsCustomerId: number;
  integrationUrl: string;
  integrationUsername?: string;
  status: EPublishStatus;
  retryable?: boolean | null;
  publishLog: IPublishResultLog | null;
}

export interface IExportToPublishResponse {
  courseId: number;
  count: number;
  results: IPublishResult[];
}

export interface IPublishLogEntry {
  creatorCourseId: number;
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  publishDate: string;
  ownerId: number;
  status: EPublishStatus;
  retryable?: boolean | null;
  lmsCustomerUrl: string;
  lmsCustomer: string;
  lmsCourseName: string;
  lmsTypeId: number;
}

export interface IGetPublishLogsByCourseResponse {
  creatorCourseId: number;
  count: number;
  logs: IPublishLogEntry[];
}

export interface ISynthesiaKeyResponse {
  ownerId: number;
  lmsCustomerId: number;
  identifier: string;
  token: string;
}
